import React from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { useSelector } from "react-redux";

type RootState = any;

const Dashboard: React.FC = () => {
  const { admin } = useSelector((state: RootState) => state.admin || {});
  const name: string = admin?.name || admin?.username || admin?.email || "User";

  // Mock stats; replace with real values when API/state is ready
  const stats = [
    { label: "Upcoming Sessions", value: 0 },
    { label: "Completed Sessions", value: 0 },
    { label: "Subscribed Gyms", value: 0 },
  ];

  const recentSessions: Array<{
    id: string;
    title: string;
    date: string;
    duration: string;
  }> = [];

  const { theme } = useTheme();

  // Dynamic classes for light/dark mode
  const bgMain =
    theme === "dark" ? "bg-gray-900 text-gray-100" : "bg-white text-gray-900";
  const bgCard =
    theme === "dark"
      ? "bg-gray-800 border-gray-700"
      : "bg-gray-100 border-gray-300";
  const textMuted = theme === "dark" ? "text-gray-400" : "text-gray-500";
  const borderDivide = theme === "dark" ? "divide-gray-700" : "divide-gray-300";
  const btnBg =
    theme === "dark"
      ? "bg-gray-700 hover:bg-gray-600"
      : "bg-gray-200 hover:bg-gray-300";

  return (
    <div className={`min-h-screen ${bgMain}`}>
      <main className="max-w-7xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-semibold">Welcome back, {name}</h1>
          <p className={`${textMuted} mt-1`}>
            Here’s an overview of your activity.
          </p>
        </div>

        {/* Stats */}
        <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
          {stats.map((s) => (
            <div key={s.label} className={`rounded-xl ${bgCard} border p-5`}>
              <div className={`text-sm ${textMuted}`}>{s.label}</div>
              <div className="text-3xl font-bold mt-2">{s.value}</div>
            </div>
          ))}
        </section>

        {/* Recent Sessions */}
        <section className={`${bgCard} rounded-xl p-5`}>
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-semibold">Recent Sessions</h2>
          </div>

          {recentSessions.length === 0 ? (
            <div className={`${textMuted} text-sm`}>
              No recent sessions found.
            </div>
          ) : (
            <ul className={`divide-y ${borderDivide}`}>
              {recentSessions.map((s) => (
                <li
                  key={s.id}
                  className="py-3 flex items-center justify-between"
                >
                  <div>
                    <p className="font-medium">{s.title}</p>
                    <p className={`text-xs ${textMuted}`}>
                      {s.date} • {s.duration}
                    </p>
                  </div>
                  <button className={`px-3 py-1.5 text-sm ${btnBg} rounded-md`}>
                    View
                  </button>
                </li>
              ))}
            </ul>
          )}
        </section>
      </main>
    </div>
  );
};

export default Dashboard;
